<template>
  <v-app-bar app color="primary" elevation="0">
    <v-toolbar flat style="background: #0d1f2b;">
      <!-- Botão da bandeira -->
      <v-btn icon color="black" @click="switchLocale">
        <flag :iso="chooseLanguage" class="elevation-10" />
      </v-btn>

      <v-spacer />

      <!-- Logo (aparece ao fazer scroll) -->
      <v-scale-transition>
        <v-img
          v-show="showHeader"
          class="shrink"
          style="margin: auto; display: block;"
          src="@/assets/logo_dream.png"
          width="100"
          contain
        />
      </v-scale-transition>

      <v-spacer />

      <!-- Botão do menu lateral -->
      <v-btn icon @click="$emit('openMenu')">
        <v-icon size="x-large" color="secondary">mdi-menu</v-icon>
      </v-btn>
    </v-toolbar>
  </v-app-bar>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n({ useScope: 'global' })

// estado
const showHeader = ref(false)

// listener para scroll
function handleScroll () {
  showHeader.value = window.scrollY > 400
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})

// trocar idioma
const chooseLanguage = computed(() => (locale.value === 'pt' ? 'gb' : 'pt'))

function switchLocale () {
  locale.value = locale.value === 'pt' ? 'en' : 'pt'
}
</script>
